import { PageTitle } from '_metronic/layout/core'
import { WithChildren } from '_metronic/helpers'

import PageBreadCrumb from 'Presentation/Components/PageBreadCrumb'

import useViewModel from './ViewModel'
import { Scanner } from '@yudiel/react-qr-scanner'
import Switch from 'react-switch'
const ProjectPileScanView: React.FC = () => {
  const {
    isDev,
    projectId,
    scanCode,
    hasCamera,
    isUseCamera,
    handleScan,
    setScanCode,
    toggleUseCamera,
    onHandleScanReceiveAll,
  } = useViewModel()

  return (
    <ViewPageTitle id={projectId ?? ''}>
      <div className='mb-5'>
        <PageBreadCrumb />
      </div>

      <div className='card mb-5'>
        <div className='card-body'>
          <div className='row gy-5'>
            <div className='col-6'>
              <h3 className='fs-4'>Scan Bar Code Here!</h3>
            </div>
            <div className='col-6'>
              <label>
                <span style={{ marginRight: 20 }}>ใช้งานกล้อง</span>
                <Switch onChange={toggleUseCamera} checked={isUseCamera} />
              </label>
            </div>
            {hasCamera && isUseCamera ? (
              <div className='col-12'>
                <Scanner
                  // facingMode='environment'
                  // delay={1000}
                  onScan={handleScan}
                  constraints={{ facingMode: 'environment' }}
                />
              </div>
            ) : (
              <div className='col-12'>
                <p>No camera found</p>
                <form
                  onSubmit={(e: any) => {
                    e.preventDefault()
                    handleScan([{ rawValue: scanCode }])
                  }}>
                  <input
                    type='text'
                    onChange={(e: any) => setScanCode(e.target.value)}
                    value={scanCode}
                    className='form-control form-control-sm'
                  />
                </form>
              </div>
            )}
            {isDev && (
              <div className='col-12'>
                <button className='btn btn-primary' onClick={onHandleScanReceiveAll}>
                  Scan All Shipping Request (Dev)
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </ViewPageTitle>
  )
}

const ViewPageTitle: React.FC<WithChildren & { id: string }> = ({ children, id }) => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            isActive: false,
            isSeparator: false,
            path: '/project',
            title: 'Project',
            icon: '/media/icons/duotune/ecommerce/ecm006.svg',
          },
          {
            isActive: false,
            isSeparator: false,
            path: `/project/${id}/shipping-request`,
            title: 'Detail',
            icon: '/media/icons/duotune/ecommerce/ecm006.svg',
          },
          {
            isActive: false,
            isSeparator: false,
            path: `#`,
            title: 'Scan',
            icon: '/media/icons/duotune/ecommerce/ecm006.svg',
          },
        ]}>
        Project Pile Scan Receive
      </PageTitle>

      {children}
    </>
  )
}

export default ProjectPileScanView
